<h2 class="mt-3 ml-5">Receipt Viewer</h2>
<hr>

<div class="main">

    <div class="photo-container">
        <ng-container *ngIf="imageUrl as photo">
          <button (click)="rotateImage()" type="button" class="btn btn-outline-info btn-sm mr-4">Döndür</button><br>       
          <img id="photo" #myImage [src]="photo" [style.transform]="'rotate(' + this.rotationAngle + 'deg)'"/>   <!-- style.transform ile css (rotate) özelliği veriyoruz. Değeri = yerel değişkenden alıyoruz. -->                     
        </ng-container>                    
    </div>
 
    <div class="row">
        <div class="col-4 offset-4 justify-content-center">
                <!-- <button *ngIf="imageUrl" (click)="rotateImage()" type="button" class="btn btn-outline-info btn-sm mr-4">Döndür</button> -->
                <button type="button" class="btn btn-success btn-sm mr-4">Kaydet</button>
                <button type="button" class="btn btn btn-info btn-sm">Güncelle</button>
        </div>
        <div class="col-12">
            <ng-container>
                <form>
                    <div class="form-group row">
                      <label for="CityCountry" class="col-sm-2 col-form-label">CityCountry</label>
                      <div class="col-8">
                        <input type="text" class="form-control" id="CityCountry" [value]="data.value.cityCountry.value">
                      </div>
                    </div>
                    <div class="form-group row">
                        <label for="LicencePlate" class="col-sm-2 col-form-label">LicencePlate</label>
                        <div class="col-8">
                          <input type="text" class="form-control" id="LicencePlate" [value]="data.value.licencePlate.value">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="MerchantAddress" class="col-sm-2 col-form-label">MerchantAddress</label>
                        <div class="col-8">
                          <input type="text" class="form-control" id="Adres" [value]="data.value.merchantAddress.value">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="MerchantName" class="col-sm-2 col-form-label">MerchantName</label>
                        <div class="col-8">
                          <input type="text" class="form-control" id="MerchantName" [value]="data.value.merchantName.value">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="PaymentType" class="col-sm-2 col-form-label">PaymentType</label>
                        <div class="col-8">
                          <input type="text" class="form-control" id="PaymentType" [value]="data.value.paymentType.value">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="TaxNo" class="col-sm-2 col-form-label">TaxNo</label>
                        <div class="col-8">
                          <input type="text" class="form-control" id="TaxNo" [value]="data.value.taxNo.value">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="Total" class="col-sm-2 col-form-label">Total</label>
                        <div class="col-8">
                          <input type="text" class="form-control" id="Total" [value]="data.value.total.value">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="TotalTax" class="col-sm-2 col-form-label">TotalTax</label>
                        <div class="col-8">
                          <input type="text" class="form-control" id="TotalTax" [value]="data.value.totalTax.value">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="TransactionDate" class="col-sm-2 col-form-label">TransactionDate</label>
                        <div class="col-8">
                          <input type="text" class="form-control" id="TransactionDate" [value]="data.value.transactionDate.value">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="TransactionId" class="col-sm-2 col-form-label">TransactionId</label>
                        <div class="col-8">
                          <input type="text" class="form-control" id="TransactionId" [value]="data.value.transactionId.value">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="TransactionTime" class="col-sm-2 col-form-label">TransactionTime</label>
                        <div class="col-8">
                          <input type="text" class="form-control" id="TransactionTime" [value]="data.value.transactionTime.value">
                        </div>
                    </div>
                </form>                
            </ng-container>           


            <ng-container>
                <table class="table table-bordered" *ngIf="data">
                    <thead>
                        <tr>
                            <th>Content</th>
                            <th>Description</th>
                            <th>Price</th>
                            <th>Quantity</th>
                            <th>QuantityUnit</th>
                            <th>Tax</th>
                            <th>TotalPrice</th>
                            <th></th>           
                        </tr>
                    </thead>
                    <tbody *ngFor="let item of items.value">
                        <tr>
                            <td>{{item.content.value}}</td>
                            <td>{{item.description.value}}</td>
                            <td>{{item.price.value}}</td>
                            <td>{{item.quantity.value}}</td>
                            <td>{{item.quantityUnit.value}}</td>
                            <td>{{item.tax.value}}</td>
                            <td>{{item.totalPrice.value}}</td>
                            <td><button type="button" class="btn btn btn-info btn-sm" (click)="openRowUpdateWindow(item)">Satır güncelle</button></td> <!-- Burada button'un click olayına bağlanan metot parametre olarak item türünde bir nesne istemeli -->
                        </tr>
                    </tbody>
                    
                </table>
            </ng-container>

        </div>

    </div>

</div>